module.exports = __webpack_public_path__ + "static/img/ding-b.dfe5b27.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ding-b.png
// module id = zul/
// module chunks = 1